// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-calendar-wrapper {
  background: var(--color-white);
  border-radius: 10px;
  padding: 16px;
}

/* Header layout */
.fc-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

/* Month title (right) */
.fc-toolbar-title {
  font-size: 20px;
  font-weight: 700;
  color: #000;
}

/* Today button (center) */
.fc .fc-button.fc-today-button {
  background-color: #fff2e7; /* blue */
  color: #000;
  border:  1px solid var(--color-primary-orange);
  font-weight: 600;
}

.fc .fc-button.fc-today-button:hover {
  background-color: var(--color-primary-orange);
  color: #000;
  border: 1px solid var(--color-primary-orange);
  font-weight: 600;
  cursor: pointer;
}

/* Prev/Next buttons (left) */
.fc .fc-button {
    background-color: #ffd9b7;
    color: #000;
    border: 1px solid var(--color-primary-orange);
    font-weight: 600;
}

.fc .fc-button:hover {
  background-color: var(--color-primary-orange);
  color: #000;
  border: 1px solid var(--color-primary-orange);
  font-weight: 600;
}

/* Events with stacked title */
.fc-daygrid-event {
  white-space: pre-line; /* allows \\n for Flex Room / Desk */
  background: #6366f1;
  border: none;
  color: var(--color-white);
  font-weight: 600;
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 12px;
}

/* "2 more" link */
.fc-daygrid-more-link {
  color: #6366f1;
  font-weight: 600;
}

/* Highlight today cell */
.fc-day-today {
  background: #dbeafe !important;
  border-radius: 6px;
}

/* Day number */
.fc-daygrid-day-number {
  font-weight: 600;
  color: #000;
}
/* Event custom container */
.fc-event-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background: #6366f1;
  color: var(--color-white);
  font-weight: 600;
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 12px;
}

/* Event text stacked */
.fc-event-text {
  white-space: pre-line;
}

/* Trash icon */
.fc-event-trash {
  margin-left: 6px;
  cursor: pointer;
  font-size: 18px;
  color: #f87171;
}

.fc-event-trash:hover {
  color: #f87171; /* red on hover */
}


/* Month & Week day headers */
.fc .fc-col-header-cell {
  background-color: var(--color-primary-green); /* your desired color */
}

/* Optional: inner cushion element */
.fc .fc-col-header-cell-cushion {
  background-color: var(--color-primary-green); /* same or different */
  color: var(--color-white);               /* header text color */
  text-decoration: none;
}

.fc .fc-daygrid-day-top a {
  text-decoration: none !important; /* Remove underline */
  color: inherit;                  /* Keep current text color */
}

.fc .fc-daygrid-day-top a:hover {
  text-decoration: none !important;
}`, "",{"version":3,"sources":["webpack://./src/containers/seat_booking/components/calender.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB,EAAE,SAAS;EACpC,WAAW;EACX,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,WAAW;EACX,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;IACI,yBAAyB;IACzB,WAAW;IACX,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,WAAW;EACX,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB,EAAE,mCAAmC;EAC1D,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,WAAW;AACb;AACA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,iBAAiB;AACnC;;;AAGA,6BAA6B;AAC7B;EACE,4CAA4C,EAAE,uBAAuB;AACvE;;AAEA,oCAAoC;AACpC;EACE,4CAA4C,EAAE,sBAAsB;EACpE,yBAAyB,gBAAgB,sBAAsB;EAC/D,qBAAqB;AACvB;;AAEA;EACE,gCAAgC,EAAE,qBAAqB;EACvD,cAAc,mBAAmB,4BAA4B;AAC/D;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".my-calendar-wrapper {\r\n  background: var(--color-white);\r\n  border-radius: 10px;\r\n  padding: 16px;\r\n}\r\n\r\n/* Header layout */\r\n.fc-toolbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Month title (right) */\r\n.fc-toolbar-title {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #000;\r\n}\r\n\r\n/* Today button (center) */\r\n.fc .fc-button.fc-today-button {\r\n  background-color: #fff2e7; /* blue */\r\n  color: #000;\r\n  border:  1px solid var(--color-primary-orange);\r\n  font-weight: 600;\r\n}\r\n\r\n.fc .fc-button.fc-today-button:hover {\r\n  background-color: var(--color-primary-orange);\r\n  color: #000;\r\n  border: 1px solid var(--color-primary-orange);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Prev/Next buttons (left) */\r\n.fc .fc-button {\r\n    background-color: #ffd9b7;\r\n    color: #000;\r\n    border: 1px solid var(--color-primary-orange);\r\n    font-weight: 600;\r\n}\r\n\r\n.fc .fc-button:hover {\r\n  background-color: var(--color-primary-orange);\r\n  color: #000;\r\n  border: 1px solid var(--color-primary-orange);\r\n  font-weight: 600;\r\n}\r\n\r\n/* Events with stacked title */\r\n.fc-daygrid-event {\r\n  white-space: pre-line; /* allows \\n for Flex Room / Desk */\r\n  background: #6366f1;\r\n  border: none;\r\n  color: var(--color-white);\r\n  font-weight: 600;\r\n  border-radius: 6px;\r\n  padding: 4px 6px;\r\n  font-size: 12px;\r\n}\r\n\r\n/* \"2 more\" link */\r\n.fc-daygrid-more-link {\r\n  color: #6366f1;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Highlight today cell */\r\n.fc-day-today {\r\n  background: #dbeafe !important;\r\n  border-radius: 6px;\r\n}\r\n\r\n/* Day number */\r\n.fc-daygrid-day-number {\r\n  font-weight: 600;\r\n  color: #000;\r\n}\r\n/* Event custom container */\r\n.fc-event-custom {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: relative;\r\n  background: #6366f1;\r\n  color: var(--color-white);\r\n  font-weight: 600;\r\n  border-radius: 6px;\r\n  padding: 4px 6px;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Event text stacked */\r\n.fc-event-text {\r\n  white-space: pre-line;\r\n}\r\n\r\n/* Trash icon */\r\n.fc-event-trash {\r\n  margin-left: 6px;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  color: #f87171;\r\n}\r\n\r\n.fc-event-trash:hover {\r\n  color: #f87171; /* red on hover */\r\n}\r\n\r\n\r\n/* Month & Week day headers */\r\n.fc .fc-col-header-cell {\r\n  background-color: var(--color-primary-green); /* your desired color */\r\n}\r\n\r\n/* Optional: inner cushion element */\r\n.fc .fc-col-header-cell-cushion {\r\n  background-color: var(--color-primary-green); /* same or different */\r\n  color: var(--color-white);               /* header text color */\r\n  text-decoration: none;\r\n}\r\n\r\n.fc .fc-daygrid-day-top a {\r\n  text-decoration: none !important; /* Remove underline */\r\n  color: inherit;                  /* Keep current text color */\r\n}\r\n\r\n.fc .fc-daygrid-day-top a:hover {\r\n  text-decoration: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
